export default function Button({
  className = "",
  variant = "primary",
  ...props
}) {
  const base =
    "px-4 py-2 rounded-xl text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed";
  const palette =
    variant === "primary"
      ? "bg-blue-700 text-white hover:bg-blue-800 shadow-sm"
      : variant === "secondary"
      ? "bg-white text-blue-700 border border-blue-200 hover:bg-blue-50 shadow-sm"
      : variant === "danger"
      ? "bg-red-600 text-white hover:bg-red-700 shadow-sm"
      : "text-slate-600 hover:bg-slate-100 hover:text-slate-900";
  return <button className={`${base} ${palette} ${className}`} {...props} />;
}
